// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UVPH","delete":"styles_delete__3qgRL","update":"styles_update__RGkiR","add":"styles_add__32xN_"};